import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "chooseFormulaPageActivationRate.title",
    defaultMessage: "Now let's choose a formula...",
  },
  formulaPageIntroDefault: {
    id: "chooseFormulaPageActivationRate.formulaPageIntroDefault",
    defaultMessage: "Use Ring Twice for different services! Ring Twice+ saves you money every time.",
  },
  formulaPageIntroLikelyRecurrent: {
    id: "chooseFormulaPageActivationRate.formulaPageIntroLikelyRecurrent",
    defaultMessage: "You'll likely need this service again. Ring Twice+ saves you money each time.",
  },
  formulaPageIntroUncertainVisit: {
    id: "chooseFormulaPageActivationRate.formulaPageIntroUncertainVisit",
    defaultMessage: "Not sure what the final cost will be? Ring Twice+ removes the service fee regardless.",
  },
  formulaPageIntroCsfGreaterRt: {
    id: "chooseFormulaPageActivationRate.formulaPageIntroCsfGreaterRt",
    defaultMessage: "Ring Twice+ costs less than the service fee on this booking. You're already saving!",
  },
  standardTitle: {
    id: "chooseFormulaPageActivationRate.standardTitle",
    defaultMessage: "Standard",
  },
  ringTwicePlusTitle: {
    id: "advantages.ringtwicePlus",
    defaultMessage: "Ring Twice<plus></plus>",
  },
  paidAfterServiceDone: {
    id: "chooseFormulaPageActivationRate.paidAfterServiceDone",
    defaultMessage: "Payed <bold>after the service is done</bold>",
  },
  serviceRow: {
    id: "chooseFormulaPageActivationRate.serviceRow",
    defaultMessage: "{serviceProviderName}'s Service",
  },
  serviceFeeRow: {
    id: "chooseFormulaPageActivationRate.serviceFeeRow",
    defaultMessage: "Service fee",
  },
  jobInsurance: {
    id: "subscriptions.activationRate.jobInsurance",
    defaultMessage: "Job insurance by AG",
  },
  noServiceFee: {
    id: "subscriptions.activationRate.noServiceFee",
    defaultMessage: "<bold>No service fee</bold> on every demand you do",
  },
  satisfiedOrRedone: {
    id: "subscriptions.activationRate.satisfiedOrRedone",
    defaultMessage: "Satisfied or redone",
  },
  cancellationFree: {
    id: "subscriptions.activationRate.cancelForFree",
    defaultMessage: "Something came up? Cancel the service for free",
  },
  subscriptionBadge: {
    id: "chooseFormulaPageActivationRate.subscriptionBadge",
    defaultMessage: "<bold>{price} / quarter</bold> · Subscription",
  },
  continueButton: {
    id: "subscriptionPurchasingFlow.continue",
    defaultMessage: "Continue",
  },
  quotePrice: {
    id: "chooseFormulaPageActivationRate.quotePrice",
    defaultMessage: "Quote",
  },
  noFeeOnQuote: {
    id: "chooseFormulaPageActivationRate.noFeeOnQuote",
    defaultMessage: "<bold>No fee</bold> on Quote",
  },
  serviceFeePercentage: {
    id: "chooseFormulaPageActivationRate.serviceFeePercentage",
    defaultMessage: "+{percentage}%",
  },
});
